// function validEmail(EMAIL) { // see:
//   var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
//   return re.test(EMAIL);
// }
// // get all data in form and return object
// function getFormData() {
//   var elements = document.getElementById("gform").elements; // all form elements
//   var fields = Object.keys(elements).map(function(k) {
//     if(elements[k].name !== undefined) {
//       return elements[k].name;
//     // special case for Edge's html collection
//     }else if(elements[k].length > 0){
//       return elements[k].item(0).name;
//     }
//   }).filter(function(item, pos, self) {
//     return self.indexOf(item) == pos && item;
//   });
//   var data = {};
//   fields.forEach(function(k){
//     data[k] = elements[k].value;
//     var str = ""; // declare empty string outside of loop to allow
//                   // it to be appended to for each item in the loop
//     if(elements[k].type === "checkbox"){ // special case for Edge's html collection
//       str = str + elements[k].checked + ", "; // take the string and append 
//                                               // the current checked value to 
//                                               // the end of it, along with 
//                                               // a comma and a space
//       data[k] = str.slice(0, -2); // remove the last comma and space 
//                                   // from the  string to make the output 
//                                   // prettier in the spreadsheet
//     }else if(elements[k].length){
//       for(var i = 0; i < elements[k].length; i++){
//         if(elements[k].item(i).checked){
//           str = str + elements[k].item(i).value + ", "; // same as above
//           data[k] = str.slice(0, -2);
//         }
//       }
//     }
//   });
//   console.log(data);
//   return data;
// }

// function handleFormSubmit(event) {  // handles form submit withtout any jquery
//   event.preventDefault();           // we are submitting via xhr below
//   var data = getFormData();         // get the values submitted in the form
  

  
  
//   if( !validEmail(data.EMAIL) ) {   // if email is not valid show error
// 	// document.getElementById('mce-error-response').style.display = 'block';
//     return false;
//   } else {
    
//     var url = event.target.action;  //
//     var xhr = new XMLHttpRequest();

    
//     xhr.open('POST', url);
// 	// xhr.withCredentials = true;
//     xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
//     xhr.onreadystatechange = function() {
//         console.log( xhr.status, xhr.statusText )
//         console.log(xhr.responseText);
//         document.getElementById('gform').style.display = 'none'; // hide form
//         document.getElementById('progressbar').style.display = 'none'; // hide progressbar
//         document.getElementById('thankyou_message').style.display = 'block';
//         return;
//     };
    
//     // url encode form data for sending as post data
//     var encoded = Object.keys(data).map(function(k) {
//         return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
//     }).join('&')
    
//     xhr.send(encoded);
//   }
// }
// function loaded() {
//   console.log('contact form submission handler loaded successfully');
  
//   // bind to the submit event of our form
//   var form = document.getElementById('gform');
//   form.addEventListener("submit", handleFormSubmit, false);
// };
// document.addEventListener('DOMContentLoaded', loaded, false);

$(function(){
  
  	// Hide other sections to start
  	$('#rugby_information, #confirm_information').hide();
  
  	// Condtional bits
  
  
  
    $('#mce-CONCUSSION-1').on('click', function(){
	  if (!$('#mce-CONCNO').length) {
           $('.reveal-if-active').append('<input type="number" name="CONCNO" class="" value="1" id="mce-CONCNO">');
      }
        
//       if ($('mce-CONCUSSION-1').is(':checked')) {
      	
//       } else {
//       	$('#mce-CONCNO').val('1').addClass('hasvalue');
//        }
    });
  
  	$('#mce-CONCUSSION-0').on('click', function(){

      	$('#mce-CONCNO').val('0').removeClass('hasvalue');
       
    });
  
  
 
  
  	
  
	$("#rugby_information .next").on('click', function(){
      
      if ($('#mce-CONCUSSION-0').is(':checked')) {
        if (!$('#mce-CONCNO').length) {
          $('.reveal-if-active').append('<input type="number" name="CONCNO" class="" value="0" id="mce-CONCNO">');
        }
      }
	
      $(".final-message").hide();
      
      if($('#mce-CONCUSSION-0').is(':checked')) {
        
        $(".final-message-1").show();
        
      } else {
        
        var myValue = $('#mce-CONCNO').val();

        if(myValue > 0 && myValue < 3) {
            $(".final-message-2").show();
        } else if(myValue >= 3) {
            $(".final-message-3").show();
        }
        
      }

  	});
  
  
 
    // Prevent wierd enter key behavior
    $('#gform input').on('keyup', function(e){
        e.preventDefault();
        if(e.keyCode == 13) {
            $('#user_information .next').trigger("click");
        }
        return false;
    });   

    // Validation rules
    $('#gform').validate({
        rules: {
          FNAME: {
            required: true,
            minlength: 2
          },
          LNAME: {
            required: true,
            minlength: 2
          },
          EMAIL: {
            required: true,
            email: true
          },
          ADDRESS1: {
            required: true,
            minlength: 2
          },
          CITY: {
            required: true,
            minlength: 2
          },
          COUNTY: {
            required: true,
            minlength: 2
          },
          POSTCODE: {
            required: true,
            minlength: 2
          },
          COUNTRY: {
            required: true,
            minlength: 2
          },
          SERIAL: {
            required: true,
            serial: true,
            maxlength: 7
          },
          YEARS: "required",
          POSITION: "required",
          confirmation: "required",
          GDPR: "required"
        }
    });

    // Custom validation for serial number
    jQuery.validator.addMethod("serial", function(value, element) {
        return this.optional( element ) || /([1-3][0-9])([1-5])([0-3][0-9][0-9][0-9]|[0-9][0-9][0-9])/g.test( value );
    }, 'Please enter your N-Pro product registration number');
  

  
  	// Naviagtion buttons
    var current_fs = $(this).parent(),
        next_fs = $(this).parent().next(),
        form = $('#gform');

    $(".next").click(function() {

        if ($(form).valid()) {
            current_fs = $(this).closest('fieldset');
            next_fs = $(this).closest('fieldset').next();
            next_fs.show();
            current_fs.hide();
            $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");
            $('html,body').scrollTop('fast');
        }

    });

    $('.previous').click(function(){

        current_fs = $(this).closest('fieldset');
        next_fs = $(this).closest('fieldset').prev();
        next_fs.show();
        current_fs.hide();
        $("#progressbar li").eq($("fieldset").index(current_fs)).removeClass("active");

    });
	
  	// Force validation at final step
    flag = false;
    $('.submit').on('click', function(e){

        if (flag === true) {
            flag = false;
            return;
        }

        e.preventDefault();

        if ($(form).valid()) {

          flag = true;
          $(this).trigger('click');
          
            document.getElementById('gform').style.display = 'none'; // hide form
			document.getElementById('progressbar').style.display = 'none'; // hide progressbar
			document.getElementById('thankyou_message').style.display = 'block';

        }

    });
  
	
  	// Find serial button
  
    $('.serial-find-button').on('click', function(e){
      e.preventDefault();
      $('.serial-find').slideToggle();     
    });
  
  
  
  
  
  
  $('.submit').on('click', function(){
  	$('.hiddensubmit').trigger('click');
  });
  
  
  
  
  
  $('#gform #mce-EMAIL').on('change', function(){
    var email = $(this).val();
	$('#thankyou_message #mce-EMAIL').val(email);
  });
  
  
  
  
  
  
//   $('#mc-embedded-subscribe-form').submit(function (e) {
//         e.preventDefault();
//         $.ajax({
//             url: '//n-pro.us14.list-manage.com/subscribe/post?u=4a0882a732ac59691f3da3daf&id=7ac9f1147f',
//             type: 'GET',
//             data: $('#mc-embedded-subscribe-form').serialize(),
//             dataType: 'jsonp',
//             contentType: "application/json; charset=utf-8",
//             success: function (data) {
//                if (data['result'] != "success") {
//                     //ERROR
//                     console.log(data['msg']);
//                } else {
//                     //SUCCESS - Do what you like here
//                     window.location = 'https://publiqly.com/blog-subscription-thank-you/';
//                }
//             }
//         });
//     });
  
  
  
    $('#news-signup-after-register').on('click',function(e){
    e.preventDefault()
  		$('.main-menu #news-signup').trigger('click')
  })
  
}());